import { initializeApp } from './app/app.config';

initializeApp().catch(err => console.error(err));
